ACC.global = {

    _autoload: [
        'bindPolyfills',
        'bindToggleOffcanvas',
        'bindToggleXsSearch',
        'initImager',
        'backToHome',
        'closeAccAlert',
        'bindModalPopupInfo',
        'bindRadioToggleWithChildContent',
        'bindCopyToClipboard',
        'showRadioChildContentIfChecked',
        'bindSelectOrganizationButton',
    ],

    // Polyfills should go here untill we put them in separate file
    bindPolyfills() {
        // endsWith polyfill for IE
        if (!String.prototype.endsWith) {
            // eslint-disable-next-line no-extend-native
            String.prototype.endsWith = function (searchString, position) {
                const subjectString = this.toString();
                // eslint-disable-next-line max-len
                if (typeof position !== 'number' || !Number.isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
                    // eslint-disable-next-line no-param-reassign
                    position = subjectString.length;
                }
                // eslint-disable-next-line no-param-reassign
                position -= searchString.length;
                const lastIndex = subjectString.indexOf(searchString, position);
                return lastIndex !== -1 && lastIndex === position;
            };
        }
    },

    bindToggleOffcanvas() {
        $(document).on('click', '.js-toggle-sm-navigation', () => {
            ACC.global.toggleClassState($('main'), 'offcanvas');
            ACC.global.toggleClassState($('html'), 'offcanvas');
            ACC.global.toggleClassState($('body'), 'offcanvas');
            ACC.global.resetXsSearch();
        });
    },

    bindToggleXsSearch() {
        $(document).on('click', '.js-toggle-xs-search', () => {
            ACC.global.toggleClassState($('.site-search'), 'active');
            ACC.global.toggleClassState($('.js-mainHeader .navigation--middle'), 'search-open');
        });
    },

    resetXsSearch() {
        $('.site-search').removeClass('active');
        $('.js-mainHeader .navigation--middle').removeClass('search-open');
    },

    toggleClassState($e, c) {
        if ($e.hasClass(c)) {
            $e.removeClass(c);
        } else {
            $e.addClass(c);
        }
        return $e.hasClass(c);
    },

    initImager(elems) {
        const elements = elems || '.js-responsive-image';
        if ($(elements).length > 0) {
            // eslint-disable-next-line no-undef
            this.imgr = new Imager(elements);
        }
    },

    reprocessImages(elems) {
        // eslint-disable-next-line no-param-reassign
        elems = elems || '.js-responsive-image';
        if (this.imgr === undefined) {
            this.initImager(elems);
        } else {
            this.imgr.checkImagesNeedReplacing($(elems));
        }
    },

    // usage: ACC.global.addGoogleMapsApi("callback function");
    // callback function name like "ACC.global.myfunction"
    addGoogleMapsApi(callback) {
        if (callback !== undefined && $('.js-googleMapsApi').length === 0) {
            // eslint-disable-next-line max-len
            $('head').append(`<script class="js-googleMapsApi" type="text/javascript" src="//maps.googleapis.com/maps/api/js?key=${ACC.config.googleApiKey}&sensor=false&callback=${callback}"></script>`);
        } else if (callback !== undefined) {
            // eslint-disable-next-line no-eval
            eval(`${callback}()`);
        }
    },

    backToHome() {
        $('.backToHome').on('click', () => {
            const sUrl = ACC.config.contextPath;
            window.location = sUrl;
        });
    },

    closeAccAlert() {
        $('.closeAccAlert').on('click', function () {
            $(this).closest('.getAccAlert').remove();
        });
    },

    bindModalPopupInfo() {
        $('.js-modal-popup').on('click', function (event) {
            // Only needed if button is "a" tag
            event.preventDefault();

            const $this = $(this);
            // Get modal content URL
            const href = event.target.getAttribute('data-source-href');
            // Adjust custom settings for modal
            let customModalSettings = {};

            if (event.target.hasAttribute('data-source-fully-modal')) {
                customModalSettings = {
                    escKey: false,
                    overlayClose: false,
                    closeButton: false,
                    trapFocus: true,
                };
            }

            if (ACC.utils.isHedTheme() && document.querySelector('.page-orderStatusContentPage')) {
                customModalSettings.onOpen = () => {
                    const modalContent = document.getElementById('cboxContent');
                    const options = {
                        childList: true,
                    };
                    const observer = new MutationObserver(((mutations) => {
                        if (mutations.length) {
                            const modalHeading = document.querySelector('#modalTitle');
                            if (modalHeading) {
                                document.querySelector('#colorbox')
                                    .setAttribute('aria-labelledby', modalHeading.id);
                            }
                        }
                    }));

                    observer.observe(modalContent, options);
                };
            }

            // Fake URL attr and force modal to load data asynchronous
            $this.attr('href', href);
            // Open modal
            $modal.open(this, customModalSettings);

            setTimeout(() => {
                ACC.global.showRadioChildContentIfChecked();
            }, 200);
        });
    },

    bindRadioToggleWithChildContent() {
        // eslint-disable-next-line no-use-before-define
        $(':input[data-radio-toggle-child]').on('click', manageRadioChildVisibility);
        // eslint-disable-next-line no-use-before-define
        $('#colorbox').on('click', ':input[data-radio-toggle-child]', manageRadioChildVisibility);
    },

    showRadioChildContentIfChecked() {
        const checkedRadioChild = $(':input[data-radio-toggle-child]:checked');
        if (checkedRadioChild) {
            checkedRadioChild.closest('.c-radiobtn').addClass('selected');
            $(`[data-radio-child-group='${checkedRadioChild.attr('name')}']`).hide();
            $(`[data-radio-child='${checkedRadioChild.attr('id')}']`).fadeIn(300);
        }
    },

    bindCopyToClipboard() {
        // eslint-disable-next-line no-undef,no-new
        new ClipboardJS('.js-copy-to-clipboard');
    },

    submitContextSwitchModalPopupForm() {
        const form = $('#contextSwitchForm');
        const showMergeCartsTrigger = $('#showMergeCartsTrigger');
        $.ajax({
            type: 'POST',
            url: form.data('action'),
            data: form.serialize(),
            complete(data) {
                if (data.status === 205) {
                    window.shouldReload = true;
                } else if (form.data('showMessage')) {
                    $('#mergedPartiesMessageId').addClass('hidden');
                    $('.js-context-account-menu  > ul').removeClass('hidden');
                }
                // eslint-disable-next-line no-unused-expressions,max-len
                showMergeCartsTrigger.length ? showMergeCartsTrigger.click() : ACC.global.reloadOrCloseModal();
            },
        });
    },

    reloadOrCloseModal() {
        if (window.shouldReload) {
            window.location.reload();
        }
        $modal.close();
    },

    bindSelectOrganizationButton() {
        $('#cboxWrapper').on('click', '.modal-content--container', () => {
            $modal.close();
            $('#existingOrg').click();
        });
    },

    isUndefinedOrNull(value) {
        return value === null || value === undefined;
    },
};

function manageRadioChildVisibility(e) {
    const target = $(e.target);
    const wrapper = target.closest('.creditcard-paypal-wrapper');
    const radio = target.closest('.c-radiobtn');
    const cBoxed = target.closest('.c-boxed');

    if (radio.hasClass('selected')) { return; }
    wrapper.find('.selected').removeClass('selected');
    radio.addClass('selected');
    cBoxed.addClass('selected');

    $(`[data-radio-child-group='${target.attr('name')}']`).hide();
    $(`[data-radio-child='${target.attr('id')}']`).fadeIn(300);

    if ($('#savedPaymentCards').length !== 0) {
        wrapper.find('.c-radiobtn__input').prop('checked', false);
        target.prop('checked', true);

        $('.checkout-paymentmethod').hide();
        $('.savedcard-billingaddress').hide();
        $('.place-order-form').hide();
        $('.saved-card-cvv').hide();
    }

    $(window).scrollTop(target.closest('.c-radiobtn').offset().top);
}

// ***** Dropdown begins *****
function dropdownParent($this) {
    let selector = $this.attr('href');
    selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, ''); // strip for ie7

    const $parent = selector && $(selector);

    return $parent && $parent.length ? $parent : $this.parent();
}

function dropdownClearMenus(e) {
    // if right click, exit
    if (e && e.which === 3) return;

    // remove class added on dropdownToggle
    $('.dropdown-backdrop').remove();

    $('.dropdown-toggle').each(function () {
        const $parent = dropdownParent($(this));

        if (!$parent.hasClass('open')) return;

        // eslint-disable-next-line max-len
        if (e && e.type === 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return;

        $parent.removeClass('open');
    });
}

// eslint-disable-next-line no-unused-vars
function dropdownToggle(e) {
    const $this = $(this);

    if ($this.is('.disabled, :disabled')) return;

    const $parent = dropdownParent($this);
    const isActive = $parent.hasClass('open');

    dropdownClearMenus();

    if (!isActive) {
        if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
            // if mobile we use a backdrop because click events don't delegate
            $(document.createElement('div'))
                .addClass('dropdown-backdrop')
                .insertAfter($(this))
                .on('click', dropdownClearMenus);
        }

        // eslint-disable-next-line no-unused-vars
        const relatedTarget = { relatedTarget: this };

        if (e.isDefaultPrevented()) return;

        // expand the <ul> on the dropdown
        $this
            .trigger('focus')
            .attr('aria-expanded', 'true');

        // set parent to open
        $parent.toggleClass('open');
    }

    // eslint-disable-next-line consistent-return
    return false;
}
//* **** Dropdown ends *****

/* #################################################################################################
   #################################################################################################

   URL sanitization
   @link: https://vanillajstoolkit.com/helpers/sanitizehtml/

 * Sanitize and encode all HTML in a user-submitted string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {String} str  The user-submitted string
 * @return {String} str  The sanitized string
 */
// eslint-disable-next-line no-unused-vars
const sanitizeHTML = function (str) {
    const temp = document.createElement('div');
    temp.textContent = str;
    return temp.innerHTML;
};

/* #################################################################################################
   #################################################################################################

   "Number" input behavior prevention

 * Prevents scroll and up/down arrow functionality in "number" inputs.
 * ( see also global.less [ line: 991 - 1008 ] )
 */

$(document).ready(() => {
    // moving focus to input, when user clicks on one of its spin buttons (fix for firefox)
    $('input[type=number]').on('click', function () {
        $(this).focus();
    });

    // Disable scroll when focused on a number input.
    $('input[type=number]').on('focus', function () {
        $(this).on('wheel', (e) => {
            e.preventDefault();
        });
    });

    // Restore scroll on number inputs.
    $('input[type=number]').on('blur', function () {
        $(this).off('wheel');
    });

    // Set minimun value to be 0
    $('input[type=number]').attr('min', 0);

    // Due to some issues with sanitization inside .jsp pages, all content that we insert with
    // backoffice for modals, we need to relocate outside any "c:" functions to preserve any
    // HTML dom tags.
    if ($('body').hasClass('page-programDetails')) {
        const modalContent = $('.program-details__attributes .modal-content--container').detach();
        $('body').append(modalContent);
    }
});
